import { useState } from 'react'
import { useTranslation } from 'next-i18next'
import useOrder from 'modules/order/state/order/use-order'
import { OrderDoubleTheDonationSliceValue } from 'modules/order/state/double-the-donation/order-double-the-donation-types'
import OrderDoubleTheDonationSelector from 'modules/order/components/double-the-donation/order-double-the-donation-selector'
import useDrawer from 'modules/drawer/state/use-drawer'
import DrawerPanel from 'modules/drawer/components/drawer-panel/drawer-panel'
import useConfig from 'modules/config/state/use-config'
import { DEFAULT_THEME_COLORS } from 'css/theme'
import { focusOnElement } from 'modules/drawer/components/drawer/drawer.utils'
import { ORDER_DOUBLE_THE_DONATION_DRAWER_OPENER_DATA_ID } from './order-double-the-donation-drawer-opener'

const OrderDoubleTheDonationDrawerPanel = () => {
  const { t } = useTranslation('common')
  const config = useConfig()

  const drawer = useDrawer({
    onClose: focusOnElement(ORDER_DOUBLE_THE_DONATION_DRAWER_OPENER_DATA_ID),
  })

  const order = useOrder()

  const isContentPanelNull = config?.contentPanel === null

  const [selectedCompany, setSelectedCompany] = useState<
    OrderDoubleTheDonationSliceValue | undefined
  >(order.doubleTheDonation.value)

  const clearSelectedCompany = () => {
    setSelectedCompany(undefined)
  }

  const onSave = () => {
    selectedCompany
      ? order.doubleTheDonation.setValue(selectedCompany)
      : order.doubleTheDonation.clearValue()

    drawer.close()
  }

  const isToggleChecked =
    config.doubleTheDonation.isPreSelected || !!order.doubleTheDonation.value?.companyId

  if (!drawer.current) {
    return null
  }

  return (
    <DrawerPanel
      title={drawer.current.label}
      closeButtonDataId="double-the-donation-drawer-close-button"
    >
      <DrawerPanel.Body>
        <OrderDoubleTheDonationSelector
          icon="employerMatch"
          isToggleChecked={isToggleChecked}
          onSelectCompany={setSelectedCompany}
          onClearCompany={clearSelectedCompany}
          company={order.doubleTheDonation.value?.companyName}
        />
      </DrawerPanel.Body>
      <DrawerPanel.Footer isMobileView={isContentPanelNull}>
        <DrawerPanel.FooterAction
          isMobileView={isContentPanelNull}
          onClick={drawer.close}
          data-id="double-the-donation-drawer-cancel-button"
        >
          {t('orderDoubleTheDonationDrawerPanel.footerAction.cancel', 'Cancel')}
        </DrawerPanel.FooterAction>
        <DrawerPanel.FooterAction
          onClick={onSave}
          data-id="double-the-donation-drawer-save-button"
          color={DEFAULT_THEME_COLORS['--theme-color--neutral-20']}
          isMobileView={isContentPanelNull}
        >
          {t('orderDoubleTheDonationDrawerPanel.footerAction.save', 'Save')}
        </DrawerPanel.FooterAction>
      </DrawerPanel.Footer>
    </DrawerPanel>
  )
}

export default OrderDoubleTheDonationDrawerPanel
